// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"CustomTooltip_tooltipContainer__6GVVf","tooltip":"CustomTooltip_tooltip__TtRxr","tooltipArrow":"CustomTooltip_tooltipArrow__K6m7J"};